import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CapacityService } from '../services/capacity.service';

/**
 * WorkOrdersSettingsResolver
 */
@Injectable({ providedIn: 'root' })
export class CapacityResolver implements Resolve<any> {
  /**
   * Constructor
   *
   * @param CapacityService CapacityService
   */
  constructor(private capacityService: CapacityService) {}

  /**
   * Resolve
   *
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   */
  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.capacityService.list();
  }
}
